import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MediaQueries, TeachAppAndLandingColorPalette as Color, } from '@lalalilo/enums';
import styled from 'styled-components';
import cross from '../assets/cross.svg';
import { NoStyleButton } from './button';
export const CookieBox = ({ children, onClose, localizedStrings, zIndex, }) => (_jsxs(Wrapper, Object.assign({ role: "region", "aria-label": localizedStrings.regionAriaLabel, zIndex: zIndex }, { children: [_jsx(CloseButton, Object.assign({ onClick: onClose }, { children: _jsx("img", { src: cross, alt: localizedStrings.closeButtonAltText }) })), children] })));
const Wrapper = styled.div `
  position: fixed;
  bottom: 35px;
  left: 35px;
  width: 420px;
  max-width: calc(100% - 70px);
  border-radius: 5px;
  box-shadow: 0 2px 20px 0 rgba(130, 178, 255, 0.15);
  background-color: #ffffff;
  z-index: ${props => { var _a; return (_a = props.zIndex) !== null && _a !== void 0 ? _a : 10; }};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  ${MediaQueries.small} {
    left: 18px;
    bottom: 10px;
    max-width: calc(100% - 36px);
  }
`;
const CloseButton = styled(NoStyleButton) `
  position: absolute;
  right: 15px;
  top: 15px;
`;
export const BoxContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px;
`;
export const Actions = styled.div `
  display: flex;
  width: 100%;
  border-top: solid 1px rgba(130, 178, 255, 0.15);
`;
export const ActionDivider = styled.div `
  border-left: solid 1px rgba(130, 178, 255, 0.15);
  height: 40px;
  width: 1px;
`;
export const Button = styled(NoStyleButton) `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 0;
  height: 40px;
  color: ${props => props.color};
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 0.03em;
`;
export const BoxIllustration = styled.img `
  width: 104px;
`;
export const BoxTitle = styled.h3 `
  font-size: 24px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  color: ${Color.grey_600};
  text-align: center;
`;
export const BoxPresentation = styled.p `
  text-align: center;
  font-size: 14px;
  color: ${Color.grey_600};
  line-height: 20px;
  margin-top: 0;
`;
//# sourceMappingURL=common.js.map